<template>
  <div class="adminUserList">
    <b-card no-body>
      <b-card-body>
        <h4 class="font-weight-bold">
          Espace de traduction
        </h4>
      </b-card-body>
    </b-card>
  </div>
</template>
<script>
  export default {
    name: 'adminUserList',
    mounted() {
    },
    data() {
    },
    layout(context) {
      return 'layout';
    },
    methods: {},
  };
</script>
